import { useMemo } from 'react';
import { useUserLocation } from '../contexts/UserLocationContext';

/**
 * هوك الهيدر — يعرض موقع المستخدم الفعلي فقط:
 *   • loading  → "جاري التحديد..."
 *   • granted  → المدينة والحي
 *   • denied / error / timeout → "اختر موقعك"
 *
 * لا يقرأ من مسودة الحجز حتى لا يعرض مدينة غير صحيحة.
 */
export const useGlobalLocation = () => {
  const { userLocation, locationStatus } = useUserLocation();

  const value = useMemo(() => {
    const city     = userLocation?.city     || null;
    const district = userLocation?.district || null;
    const coords   = userLocation?.lat && userLocation?.lng ? userLocation : null;

    const hasCityOrDistrict = Boolean(city || district);

    const isLoading = locationStatus === 'loading';
    const isDenied  = locationStatus === 'denied';

    const displayLabel = isLoading
      ? 'جاري التحديد...'
      : city
        ? city
        : 'اختر موقعك';

    return {
      location: coords ? { ...coords, city, district } : { city, district },
      displayLabel,
      hasLocation: hasCityOrDistrict || Boolean(coords),
      locationStatus,
      isLoading,
      isDenied,
    };
  }, [userLocation, locationStatus]);

  return value;
};
